export const BEST_COUPON_STORES = [
  { storeName: 'Amazon', storeSlug: 'amazon' },
  { storeName: 'Mercado Livre', storeSlug: 'mercado-livre' },
  { storeName: 'Netshoes', storeSlug: 'netshoes' },
  { storeName: 'Magazine Luiza', storeSlug: 'magazine-luiza' },
  { storeName: 'Aliexpress', storeSlug: 'aliexpress' },
  { storeName: 'KaBuM!', storeSlug: 'kabum' },
];

const FALLBACK_RELATED_STORES = [
  { storeName: 'Mercado Livre', storeSlug: 'mercado-livre' },
  { storeName: 'KaBuM!', storeSlug: 'kabum' },
  { storeName: 'Amazon', storeSlug: 'amazon' },
  { storeName: 'Magazine Luiza', storeSlug: 'magazine-luiza' },
  { storeName: 'Aliexpress', storeSlug: 'aliexpress' },
  { storeName: 'Netshoes', storeSlug: 'netshoes' },
];

const STORE_NAMES = {
  adidas: 'Adidas',
  aliexpress: 'Aliexpress',
  amazon: 'Amazon',
  americanas: 'Americanas',
  animale: 'Animale',
  'beleza-na-web': 'Beleza na Web',
  carrefour: 'Carrefour',
  'casas-bahia': 'Casas Bahia',
  cea: 'C&A',
  centauro: 'Centauro',
  'compra-certa': 'Compra Certa',
  dufrio: 'Dufrio',
  emma: 'Emma',
  extra: 'Extra',
  fastshop: 'Fastshop',
  ifood: 'iFood',
  kabum: 'KaBuM!',
  'loja-electrolux': 'Electrolux',
  'loja-lg': 'LG',
  'loja-multilaser': 'Multilaser',
  'magazine-luiza': 'Magazine Luiza',
  malwee: 'Malwee',
  marisa: 'Marisa',
  'mercado-livre': 'Mercado Livre',
  natura: 'Natura',
  netshoes: 'Netshoes',
  nike: 'Nike',
  oboticario: 'O Boticário',
  pichau: 'Pichau',
  'ponto-frio': 'Ponto Frio',
  samsung: 'Samsung',
  shopclub: 'Shopclub',
  shopee: 'Shopee',
  shoptime: 'Shoptime',
  stanley: 'Stanley',
  submarino: 'Submarino',
  zattini: 'Zattini',
};

const STORE_TO_CATEGORY = {
  // Marketplaces e Varejo Geral
  aliexpress: 'diversos',
  amazon: 'diversos',
  americanas: 'diversos',
  carrefour: 'diversos',
  'casas-bahia': 'diversos',
  extra: 'diversos',
  'magazine-luiza': 'diversos',
  'mercado-livre': 'diversos',
  'ponto-frio': 'diversos',
  shopee: 'diversos',
  shoptime: 'diversos',
  submarino: 'diversos',

  // Eletrônicos e Tecnologia
  fastshop: 'smartphones-eletronicos-e-tv',
  kabum: 'smartphones-eletronicos-e-tv',
  'loja-lg': 'smartphones-eletronicos-e-tv',
  'loja-multilaser': 'smartphones-eletronicos-e-tv',
  pichau: 'smartphones-eletronicos-e-tv',
  samsung: 'smartphones-eletronicos-e-tv',

  // Moda e Esportes
  adidas: 'moda-e-acessorios',
  animale: 'moda-e-acessorios',
  cea: 'moda-e-acessorios',
  centauro: 'moda-e-acessorios',
  malwee: 'moda-e-acessorios',
  marisa: 'moda-e-acessorios',
  netshoes: 'moda-e-acessorios',
  nike: 'moda-e-acessorios',
  zattini: 'moda-e-acessorios',

  // Beleza e Cuidados Pessoais
  'beleza-na-web': 'saude-e-beleza',
  natura: 'saude-e-beleza',
  oboticario: 'saude-e-beleza',

  // Casa, Eletro e Utensílios
  'compra-certa': 'casa-e-eletrodomesticos',
  dufrio: 'casa-e-eletrodomesticos',
  emma: 'casa-e-eletrodomesticos',
  'loja-electrolux': 'casa-e-eletrodomesticos',
  shopclub: 'casa-e-eletrodomesticos',
  stanley: 'casa-e-eletrodomesticos',

  // Alimentação
  ifood: 'supermercado-delivery',
};

const CATEGORY_TO_STORES = Object.entries(STORE_TO_CATEGORY).reduce(
  (acc, [slug, category]) => {
    if (!acc[category]) acc[category] = [];
    acc[category].push(slug);
    return acc;
  },
  {}
);

export const HIGHLIGHTED_STORES = [
  { storeName: 'Adidas', storeSlug: 'adidas' },
  { storeName: 'Aliexpress', storeSlug: 'aliexpress' },
  { storeName: 'Amazon', storeSlug: 'amazon' },
  { storeName: 'Americanas', storeSlug: 'americanas' },
  { storeName: 'Animale', storeSlug: 'animale' },
  { storeName: 'Beleza na Web', storeSlug: 'beleza-na-web' },
  { storeName: 'Carrefour', storeSlug: 'carrefour' },
  { storeName: 'Casas Bahia', storeSlug: 'casas-bahia' },
  { storeName: 'C&A', storeSlug: 'cea' },
  { storeName: 'Centauro', storeSlug: 'centauro' },
  { storeName: 'Compra Certa', storeSlug: 'compra-certa' },
  { storeName: 'Dufrio', storeSlug: 'dufrio' },
  { storeName: 'Emma', storeSlug: 'emma' },
  { storeName: 'Extra', storeSlug: 'extra' },
  { storeName: 'Fastshop', storeSlug: 'fastshop' },
  { storeName: 'iFood', storeSlug: 'ifood' },
  { storeName: 'KaBuM!', storeSlug: 'kabum' },
  { storeName: 'Electrolux', storeSlug: 'loja-electrolux' },
  { storeName: 'LG', storeSlug: 'loja-lg' },
  { storeName: 'Multilaser', storeSlug: 'loja-multilaser' },
  { storeName: 'Magazine Luiza', storeSlug: 'magazine-luiza' },
  { storeName: 'Malwee', storeSlug: 'malwee' },
  { storeName: 'Marisa', storeSlug: 'marisa' },
  { storeName: 'Mercado Livre', storeSlug: 'mercado-livre' },
  { storeName: 'Natura', storeSlug: 'natura' },
  { storeName: 'Netshoes', storeSlug: 'netshoes' },
  { storeName: 'Nike', storeSlug: 'nike' },
  { storeName: 'O Boticário', storeSlug: 'oboticario' },
  { storeName: 'Pichau', storeSlug: 'pichau' },
  { storeName: 'Ponto Frio', storeSlug: 'ponto-frio' },
  { storeName: 'Samsung', storeSlug: 'samsung' },
  { storeName: 'Shopclub', storeSlug: 'shopclub' },
  { storeName: 'Shopee', storeSlug: 'shopee' },
  { storeName: 'Shoptime', storeSlug: 'shoptime' },
  { storeName: 'Stanley', storeSlug: 'stanley' },
  { storeName: 'Submarino', storeSlug: 'submarino' },
  { storeName: 'Zattini', storeSlug: 'zattini' },
  { storeName: 'Todos cupons →', storeSlug: null, href: '/cupons/' },
];

export const getRelatedStores = (storeSlug) => {
  const category = STORE_TO_CATEGORY[storeSlug];
  const slugs = category ? CATEGORY_TO_STORES[category] : null;

  if (!slugs) return FALLBACK_RELATED_STORES;

  const peers = slugs.filter((s) => s !== storeSlug);

  if (peers.length === 0) return FALLBACK_RELATED_STORES;

  return peers.map((s) => ({ storeName: STORE_NAMES[s] ?? s, storeSlug: s }));
};
